import { throttle } from 'lodash';

/**
 * Fixed flyout component
 */
export function FixedFlyout() {
	const flyoutItem = document.querySelectorAll( '.jdrf-fixedflyout' )[0];
	const contentContainer = document.getElementById( 'spirit-shell-main' );

	if ( !flyoutItem || !contentContainer ) {
		return;
	}

	// Setup defaults
	const flyoutContent = flyoutItem.querySelector( '.jdrf-fixedflyout__content' );
	const flyoutToggle = flyoutItem.querySelector( '.jdrf-fixedflyout__toggle' );
	const flyoutTitle = flyoutItem.querySelector( '.jdrf-fixedflyout__title' );

	flyoutToggle.href = '#fixed-flyout-content';
	flyoutContent.id = flyoutToggle.href.replace( '#', '' );
	flyoutTitle.id = 'jdrf-fixedflyout-title';
	flyoutToggle.setAttribute( 'aria-controls', flyoutContent.id );
	flyoutToggle.setAttribute( 'aria-haspopup', 'true' );
	flyoutToggle.setAttribute( 'aria-expanded', 'true' );
	flyoutContent.setAttribute( 'aria-labelledby', flyoutTitle.id );
	flyoutContent.setAttribute( 'aria-hidden', 'false' );

	/**
	 * Set default accessbility settings for hide state
	 *
	 * @returns {void}
	 */
	const flyoutAllyHide = () => {
		flyoutItem.setAttribute( 'aria-hidden', 'true' );
	};

	/**
	 * Set default accessbility settings for show state
	 *
	 * @returns {void}
	 */
	const flyoutAllyShow = () => {
		flyoutItem.setAttribute( 'aria-hidden', 'false' );
		flyoutToggle.setAttribute( 'aria-expanded', 'true' );
		flyoutContent.setAttribute( 'aria-hidden', 'false' );
	};

	/**
	 * Construct flyout
	 *
	 * @returns {void}
	 */
	const constructFlyout = () => {
		flyoutAllyHide();

		flyoutItem.classList.add( 'jdrf-fixed-flyout--fixed' );
		displayFlyout();
		toggleFlyoutAction();
		window.addEventListener( 'scroll', displayOnScroll );
	};

	/**
	 * Destroy flyout
	 *
	 * @returns {void}
	 */
	const destroyFlyout = () => {
		flyoutAllyShow();

		flyoutItem.classList.remove( 'jdrf-fixed-flyout--fixed' );
		toggleFlyoutAction( false );
		window.removeEventListener( 'scroll', displayOnScroll );
	};

	/**
	 * Initialize flyout
	 *
	 * @returns {void}
	 */
	const flyoutInit = () => {
		const flyoutBreak = flyoutItem.dataset.fixedflyout;

		if ( 'fixedflyout--lg' !== flyoutBreak || ( 'fixedflyout--lg' === flyoutBreak && window.matchMedia( '(min-width: 1024px)' ).matches ) ) {
			constructFlyout();
		} else {
			destroyFlyout();
		}
	};

	/**
	 * Show flyout
	 *
	 * @returns {void}
	 */
	const showFlyout = ( action ) => {
		if( action  ) {
			flyoutItem.setAttribute( 'aria-hidden', 'false' );
		} else {
			flyoutAllyHide();
		}
	};

	/**
	 * Toggle flyout content via button
	 *
	 * @returns {void}
	 */
	const toggleFlyout = ( event ) => {
		const isExpanded = ( 'true' === flyoutToggle.getAttribute( 'aria-expanded' ) );
		event.preventDefault();
		event.stopPropagation();

		if ( isExpanded ) {
			flyoutContent.setAttribute( 'aria-hidden', true );
			flyoutToggle.setAttribute( 'aria-expanded', false );
		} else {
			flyoutContent.setAttribute( 'aria-hidden', false );
			flyoutToggle.setAttribute( 'aria-expanded', true );
		}
	};

	/**
	 * Add event listeners to flyout toggle button
	 *
	 * @returns {void}
	 */
	const toggleFlyoutAction = ( active = true ) => {
		const flyoutToggleButton = flyoutItem.querySelector( '.jdrf-fixedflyout__toggle' );

		if ( ! flyoutToggleButton ) {
			return;
		}

		if ( active ) {
			flyoutToggleButton.addEventListener( 'click', toggleFlyout );
		} else {
			flyoutToggleButton.removeEventListener( 'click', toggleFlyout );
		}

	};

	/**
	 * Measure page scroll to display flyout
	 *
	 * @returns {void}
	 */
	const displayFlyout = () => {

		const progressTop = contentContainer.offsetTop;
		const targetData = contentContainer.getBoundingClientRect();
		const elHeight = targetData.height;
		const elBottom = targetData.bottom;
		const offset = document.documentElement.clientHeight * 1;
		const newHeight = elHeight - offset;
		const newBottom = elBottom - progressTop - offset;
		const newPercentage = ( 1 - ( newBottom / newHeight ) ) * 100;

		if( newPercentage && ( 50 < Math.min( 100, newPercentage ) ) ) {
			showFlyout( true );
		} else {
			showFlyout( false );
		}
	};

	/**
	 * Add event listener (animation frame) to toggle display flyout on scroll
	 *
	 * @returns {void}
	 */
	const displayOnScroll = () => {

		window.requestAnimationFrame( () => {
			displayFlyout();
		} );
	};

	flyoutInit();
	window.addEventListener( 'resize', throttle( flyoutInit, 200 ) );
}
